import * as types from './constants';

// Get Base Commission Rate
export const getBaseCommissionRateRequest = data => (
  { type: types.GET_BASE_COMMISSION_RATE_REQUEST, payload: data }
);

export const getBaseCommissionRateDone = data => (
  { type: types.GET_BASE_COMMISSION_RATE_DONE, payload: data }
);

export const getBaseCommissionRateFailed = errors => (
  { type: types.GET_BASE_COMMISSION_RATE_FAILED, payload: errors }
);